import "./PlanosSection.css";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdOutlineSupportAgent } from "react-icons/md";
import { LuHelpingHand } from "react-icons/lu";
import { FaRegHandshake } from "react-icons/fa6";
const AreaPlanos = () => {
    
  return (
    <section class="planos-section" id="planos">
      <div class="container-planos">
        <div class="section-header">
          <h2>ULTRA VELOCIDADE</h2>
          <p class="section-subtitle">
            Confira nossos planos de internet com a melhor relação
            custo-benefício da região
          </p>
        </div>

        <div class="plano-tipo-filtro">
          <button class="filtro-btn active" data-filtro="todos">
            Todos os Planos
          </button>
          <button class="filtro-btn" data-filtro="fibra">
            Fibra Óptica
          </button>
          <button class="filtro-btn" data-filtro="wireless">
            Wireless
          </button>
        </div>

        <div class="planos-grid">
          <div class="plano-card" data-tipo="wireless">
            <div class="plano-badge">POPULAR</div>
            <div class="plano-header">
              <i class="fas fa-rocket plano-icone"></i>
              <div class="plano-velocidade">20 MEGA</div>
              <div class="plano-tipo">Wireless</div>
            </div>

            <div class="plano-body">
              <div class="plano-preco">
                <div class="preco-valor">
                  R$ 70,00
                </div>
                <div class="preco-periodo">por mês</div>
              </div>

              <ul class="plano-beneficios">
              <li>
                  <i class="fas fa-check"></i>{" "}
                  <strong>Wireless pura</strong> - Planos Até 50 Mega
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Conexão estável</strong>{" "}
                  - 24h por dia
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Wi-Fi Grátis </strong> -
                   Router incluso
                </li>
                
                <li>
                  <i class="fas fa-check"></i> <strong>Suporte técnico</strong>{" "}
                  - especializado
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Atendimento</strong>-  via
                   WhatsApp
                </li>
              </ul>

              <div class="plano-cta">
                <a
                  href="https://wa.me/5538998988942?text=Olá! Gostaria de contratar o plano de 20 Mega"
                  target="_blank"
                  class="btn-contratar"
                >
                  <i class="fab fa-whatsapp"></i> Contratar Plano
                </a>
              </div>
            </div>
          </div>

          <div class="plano-card destaque" data-tipo="fibra">
            <div class="plano-badge">MAIS VENDIDO</div>
            <div class="plano-header">
              <i class="fas fa-bolt plano-icone"></i>
              <div class="plano-velocidade">30 MEGA</div>
              <div class="plano-tipo">Wireless</div>
            </div>

            <div class="plano-body">
              <div class="plano-preco">
                <div class="preco-valor">
                  R$ 85,00
                </div>
                <div class="preco-periodo">por mês</div>
              </div>

              <ul class="plano-beneficios">
                <li>
                  <i class="fas fa-check"></i>{" "}
                  <strong>Wireless </strong> -Planos Até 50 Mega
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Wi-Fi Dual Band</strong>{" "}
                  - Router 5G
                </li>
                
                <li>
                  <i class="fas fa-check"></i> <strong>Suporte 24h</strong>{" "}- 
                  todos os dias
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Garantia</strong>- de
                  velocidade
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Ideal</strong>- para
                  streaming
                </li>
              </ul>

              <div class="plano-cta">
                <a
                  href="https://wa.me/5538998988942?text=Olá! Gostaria de contratar o plano de 30 Mega"
                  target="_blank"
                  class="btn-contratar"
                >
                  <i class="fab fa-whatsapp"></i> Contratar Agora
                </a>
              </div>
            </div>
          </div>

          <div class="plano-card" data-tipo="fibra">
            <div class="plano-badge">POWER</div>
            <div class="plano-header">
              <i class="fas fa-fire plano-icone"></i>
              <div class="plano-velocidade">50 MEGA</div>
              <div class="plano-tipo">Fibra Óptica</div>
            </div>

            <div class="plano-body">
              <div class="plano-preco">
                <div class="preco-valor">
                  R$ 70,00
                </div>
                <div class="preco-periodo">por mês</div>
              </div>

              <ul class="plano-beneficios">
                <li>
                  <i class="fas fa-check"></i>{" "}
                  <strong>Fibra óptica pura</strong> - Planos Até 200 Mega
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Wi-Fi 5G</strong> -
                  Router premium
                </li>
               
                <li>
                  <i class="fas fa-check"></i>{" "}
                  <strong>Suporte prioritário</strong>- 24h
                </li>
                <li>
                  <i class="fas fa-check"></i> <strong>Ideal para jogos</strong>{" "}-
                  online
                </li>
                <li>
                  <i class="fas fa-check"></i>{" "}
                  <strong>Até 10 dispositivos</strong>- simultâneos
                </li>
              </ul>

              <div class="plano-cta">
                <a
                  href="https://wa.me/5538998988942?text=Olá! Gostaria de contratar o plano de 50 Mega"
                  target="_blank"
                  class="btn-contratar"
                >
                  <i class="fab fa-whatsapp"></i> Contratar Plano
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="garantia-satisfacao">
          <p>
            <strong>Garantia de satisfação:</strong> Se não gostar dos nossos
            serviços nos primeiros 30 dias, devolvemos seu dinheiro! *Consulte
            condições
          </p>
        </div>
      </div>
    </section>
  );
 
};
export default AreaPlanos;
